<qai-post-call
  [title]="title"
  [subtitle]="subtitle()"
  [state]="state()"
  (ctaClick)="onCtaClick()"
  [ctaText]="resolvedCtaLabel()"
>
  @if (state() != "error") {
    <qai-call-feedback qaiCallFeedback [class.no-left-content]="noLeftContent()">
      <ng-container qaiLeft>
        @if (!feedbackSubmitted()) {
          <p class="feedback-text">{{ feedbackQuestion }}</p>
        } @else {
          @if (selectedFeedback() === true) {
            <qai-glyph
              [kind]="'partying-face'"
              [size]="'48px'"
              [spotlight]="'brand'"
            ></qai-glyph>
          }
        }
      </ng-container>

      <ng-container qaiRight>
        @if (!feedbackSubmitted()) {
          <div class="feedback-actions">
            <button
              (click)="submitFeedback(true)"
              class="feedback-btn"
              aria-label="Thumbs up"
              type="button"
            >
              <qai-glyph
                [kind]="'filled-thumbs-up'"
                [size]="'22px'"
              ></qai-glyph>
            </button>
            <button
              (click)="submitFeedback(false)"
              class="feedback-btn"
              aria-label="Thumbs down"
              type="button"
            >
              <qai-glyph
                [kind]="'filled-thumbs-down'"
                [size]="'22px'"
              ></qai-glyph>
            </button>
          </div>
        } @else {
          <div class="feedback-submitted-text">
            <p class="feedback-text">{{ thankYouMessagePositive }}</p>
            @if (selectedFeedback() === false) {
              <p class="feedback-text">{{ feedbackImprovementSuffix }}</p>
            }
          </div>
        }
      </ng-container>
    </qai-call-feedback>
  }
</qai-post-call>
